__turbopack_context__.v({
  "container": "Footer-module-scss-module__wcgw9G__container",
  "description": "Footer-module-scss-module__wcgw9G__description",
  "footer": "Footer-module-scss-module__wcgw9G__footer",
  "legalLink": "Footer-module-scss-module__wcgw9G__legalLink",
  "root": "Footer-module-scss-module__wcgw9G__root",
  "socialLinks": "Footer-module-scss-module__wcgw9G__socialLinks",
  "watermark": "Footer-module-scss-module__wcgw9G__watermark",
  "watermarkWrapper": "Footer-module-scss-module__wcgw9G__watermarkWrapper",
});
